import { useAuth } from 'context/AuthProvider'
import { CurrentUser } from 'customTypes'
import { getCoachDescriptor } from 'utils/coach'
import { useCurrentUserQuery } from 'types'

interface CoachLabelProps {
  currentUser?: CurrentUser
  capitalized?: boolean
  plural?: boolean
}

export const CoachLabel = ({
  currentUser: currentUserProp,
  capitalized = false,
  plural = false
}: CoachLabelProps) => {
  const { isAuthorized, isInitializing } = useAuth()
  const { data: { currentUser } = {} } = useCurrentUserQuery({
    skip: !!currentUserProp || !isAuthorized || isInitializing
  })

  const user = currentUserProp ?? currentUser
  const descriptor = getCoachDescriptor(user, { capitalized, plural })

  return descriptor.toString() || null
}
